import React, { memo } from 'react';
import { motion } from 'framer-motion';
const KITS = [{
  id: '41',
  title: 'Fluidez en la lectura',
  desc: 'Ejercicios diarios para que tu hijo lea en voz alta más seguro, sin pausas eternas y con mejor ritmo.',
  color: 'bg-blue-50 border-blue-200',
  titleColor: 'text-blue-800'
}, {
  id: '42',
  title: 'Escritura clara y ordenada',
  desc: 'Actividades para trabajar ortografía, redacción y vocabulario desde casa, paso a paso.',
  color: 'bg-pink-50 border-pink-200',
  titleColor: 'text-pink-800'
}, {
  id: '43',
  title: 'Comprensión total',
  desc: 'Para que no solo “lea”, sino que entienda y pueda explicar con sus palabras lo que leyó.',
  color: 'bg-green-50 border-green-200',
  titleColor: 'text-green-800'
}, {
  id: '44',
  title: 'Motivación y hábito lector',
  desc: 'Estrategias y dinámicas para que leer deje de ser castigo y se vuelva hábito (sí, existe esa realidad paralela 😄).',
  color: 'bg-yellow-50 border-yellow-200',
  titleColor: 'text-yellow-800'
}];
export function KitDetails() {
  return <section className="py-16 px-4 bg-[#FFFDE7]" data-id="element-131">
      {' '}
      {/* Soft yellow pastel */}
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-12" data-id="element-133">
          📘 ¿Qué incluye exactamente el <br className="hidden md:block" data-id="element-134" />
          <span className="text-blue-600" data-id="element-135">MEGA KIT LECTOESCRITURA?</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-136">
          {KITS.map((kit, index) => <motion.div key={kit.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-8 rounded-2xl border-2 ${kit.color} bg-white shadow-lg`} data-id="element-137">
              <h3 className={`text-2xl font-black mb-4 ${kit.titleColor}`} data-id="element-138">
                ✅ KIT #{kit.id} — {kit.title}
              </h3>
              <p className="text-lg text-gray-700 font-medium" data-id="element-139">{kit.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-gray-200" data-id="element-140">
          <h3 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-8" data-id="element-141">
            Además, incluye recursos clave:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-142">
            {['Actividades visuales y auditivas', 'Ejercicios progresivos (no salteás pasos)', 'Caligrafías, trazos y motricidad fina', 'Cuadernillos de conciencia fonológica y memoria visual', 'Guía sobre dislexia + orientación para padres y docentes', '+50 recursos imprimibles (tarjetas, fichas y juegos)'].map((item, i) => <div key={i} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-143">
                <span className="text-green-500 text-xl flex-shrink-0" data-id="element-144">✅</span>
                <span className="font-semibold text-gray-800" data-id="element-145">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}